import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

export const MobileDonateBar = () => {
  const { t, lang } = useLang();
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const target = document.getElementById("donate");
    let donateInView = false;
    let scrolled = false;
    const update = () => setVisible(scrolled && !donateInView);
    const onScroll = () => {
      scrolled = window.scrollY > 500;
      update();
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    let obs;
    if (target) {
      obs = new IntersectionObserver(
        ([e]) => { donateInView = e.isIntersecting; update(); },
        { threshold: 0.05 }
      );
      obs.observe(target);
    }
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      obs?.disconnect();
    };
  }, [pathname]);

  if (pathname.startsWith("/admin")) return null;
  const href = pathname === "/" ? "#donate" : "/#donate";

  return (
    <div
      data-testid="mobile-donate-bar"
      className={`fixed bottom-0 inset-x-0 z-40 md:hidden transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full pointer-events-none"
      }`}
    >
      <div className="bg-[hsl(160_38%_12%)]/95 backdrop-blur-md border-t border-white/10 px-5 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] flex items-center justify-between gap-4">
        <p className="text-[hsl(42_33%_96%)]/70 text-xs leading-snug">
          <span className="block font-serif text-sm text-[hsl(42_33%_96%)]">Findivine</span>
          {lang === "hi" ? "हर रुपया सीधे सेवा तक पहुँचता है।" : "Every rupee reaches the field."}
        </p>
        <a
          href={href}
          data-testid="mobile-donate-btn"
          className="shrink-0 rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-semibold"
        >
          {t("nav.donateNow")}
        </a>
      </div>
    </div>
  );
};
